
const keys = {
    TOKEN: 'vue_app_token',
    USER: 'vue_app_user',
    TASKS: 'vue_app_tasks',
    LISTS: 'vue_app_lists',
    CATEGORIES: 'vue_app_categories',
};

export default keys;
